// deps
import React, { memo, useCallback } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";

// styles
import { TransactionBtnWrapper } from "./styles";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { FOOTER_TEXTS } from "@dineout-payment-success-ui/constants/Footer";

// test-ids
import { PAYMENT_SUCCESS_FOOTER } from "@swiggy-private/payment-test-ids";

// types
import { ITransactionCompleteBtn } from "@dineout-payment-success-ui/interfaces";

const TransactionCompleteBtn: React.FC<ITransactionCompleteBtn> = ({
    customDoneCtaText,
    doneClickHandler,
    isFullWidthCta = false,
    doneClickEventHandler,
    doneImpressionEventHandler,
}) => {
    const handleDoneClick = useCallback(() => {
        doneClickEventHandler?.();
        doneClickHandler();
    }, [doneClickEventHandler, doneClickHandler]);

    useEffectOnce(() => {
        doneImpressionEventHandler?.();
    });

    return (
        <TransactionBtnWrapper
            onClick={handleDoneClick}
            data-testid={PAYMENT_SUCCESS_FOOTER.DONE_BTN}
            isFullWidthCta={isFullWidthCta}
        >
            <Text variant="V2.body1.neutral.bold" color="text_Button_Primary">
                {customDoneCtaText || FOOTER_TEXTS.PAYMENT_DONE}
            </Text>
        </TransactionBtnWrapper>
    );
};

export default memo(TransactionCompleteBtn);
